import { jsx as _jsx } from "react/jsx-runtime";
import { Button, Popconfirm } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { useI18n } from '@newtontechnologies/applib-frontend';
import './style.less';
const DeleteTask = ({ taskId, onDelete }) => {
    const { intl } = useI18n();
    return (_jsx(Popconfirm, { title: intl.formatMessage({ id: 'irreversibleWarning' }), okText: intl.formatMessage({ id: 'deleteTask' }), okType: "danger", onConfirm: () => onDelete(taskId), cancelText: intl.formatMessage({ id: 'cancel' }), children: _jsx(Button, { shape: "circle", icon: _jsx(DeleteOutlined, {}) }) }));
};
export default DeleteTask;
